'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './mail-composer.routes';

export class MailComposerComponent {

  constructor(Auth, $q, Upload, prompt, dialogs, StorageService, MailsService, $uibModal, $state, $stateParams, $location, SettingsService) {
    'ngInject';

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.MailsService = MailsService;
    this.$state = $state;
    this.Auth = Auth;
    this.$location = $location;
    this.StorageService = StorageService;
    this.SettingsService = SettingsService;
    this.Upload = Upload;
    this.prompt = prompt;
    this.$q = $q;
    this.assets = [];

    this.hideViewOnline = false;

    this.totalAttachmentSize = _ => this.assets.reduce((totalSize, asset) => totalSize + asset.size, 0);

    this.SettingsService.getByName({name: 'config.platform'}, setting => {
      this.baseUrl = setting.data.baseURL;
    });

    this.templates = [];

    this.SettingsService.getByName({name: 'default-mailblast-templates'}, setting => {
      this.templates = this.templates.concat(setting.data.map(template => { template.type = 'Default Templates'; return template; }));
    });

    this.sortableOptions = {
        handle: '.handle'
    };

    var that = this;

    this.dropHandler = function( file, insertAction ) {

      var isImage = that.isImageMime(file.type);
      var isPdf = that.isPdfMime(file.type);

      // validation
      if( !isImage && !isPdf) {
        // ignore other file than images and pdfs
        return;
      }

      /* could check for file size: if( file.size > 500000 ) */

      var defer = that.$q.defer();

      that.Upload.upload({
        url: '/api/storage',
        data: {
          name: file.name,
          file: file,
          storageStrategy: 'local',
          isPublic: true,
          creationUser: that.Auth.getCurrentUserSync()._id,
          active: true
        }
      }).then((response) => {

        if (isImage) {
          insertAction( "insertImage", that.baseUrl + "/api/storage/" + response.data, true );
          defer.resolve(true);
        } else if (isPdf) {
          that.StorageService.getMeta({id: response.data}, data => {

            that.prompt({
              title: 'Define Link Text',
              message: 'What would you like to name the link to the file?',
              input: true,
              value: data.filename
            }).then(function(name){

              insertAction('insertHTML','<a target="_blank" href="'+that.baseUrl+'/api/storage/'+data._id+'">'+name+'</a><br/>');

              defer.resolve(true);

            }, function() {
              defer.reject();
            });

          }, err => {
            console.log('could not retrieved storage from server');
            defer.reject();
          });
        }

      }, (response) => {
        if (response.status > 0) {
          alert(response.status + ': ' + response.data);
          defer.reject();
        }
      });

      return defer.promise;

    };

    this.optionsImagesPerRow = [1,2,3,4];

    this.mailId = $stateParams.id;

    this.mail = {
      subject: '',
      sections: [],
      body: "",
      type: 'draft',
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    if (this.mailId) {
      this.MailsService.get({id: this.mailId}, data => {
        this.mail = data;
        this.assets = data.attachments;

        this.assets.forEach(asset => {
          this.StorageService.getFileSize({id: asset._id}, data2 => {
            asset.size = 4*(data2.size/3); // calc base64 size (as 10MB is hard limit after base64 encoding)
          });
        });

        this.SettingsService.getByName({name: 'default-mailblast-templates'}, setting => {

          let idx = setting.data.findIndex(template => {return template.name == this.mail.template});
          let template = setting.data[idx];

          this.generateDefaultMailTemplate(template);
        });

      }, err => {
        console.log('Could not load mail from server');
      })
    }

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h3","h4","h5"],
      ["p","quote","clear"],
      ["ul","ol"],
      ["insertLink"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

  }


  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  removeAttachment(idx) {
    this.assets.splice(idx,1);
  }

  generateDefaultMailTemplate(template) {
    let html = ['<p style="font-size: 12pt;text-align: center;text-align: center;"><a href="{tmpl:mailurl}" style="font-size: 13px;">Click here</a><span style="font-size: 13px;float: none;"> to view this online</span><br></p>'];

    if (this.hideViewOnline)
      html = [];

    let imageUrl = "https://s3.amazonaws.com/conduu-cdn/mail/mailblast/" + template.filename;

    switch (template.style) {
      case 'full':
        html.push('<p><img src="' + imageUrl + '" style="width: 100%;"></p>');
        break;
      case 'center':
      default:
        html.push('<h1 style="text-align: center;"><img src="' + imageUrl + '">​</h1>');
        break;
    }

    html.push('<p style="text-align: left;font-size: 12pt;">{tmpl:section-start}</p><div><div class="WordSection1"><p style="font-size: 12pt;"><b><span style="font-size: 15pt;">{tmpl:section-heading}</span></b><b><span style="font-size: 15pt;"> </span></b><span style="font-size: 15pt;">&nbsp;{tmpl:section-content}</span></p></div></div> <p style="text-align: left;font-size: 12pt;">{tmpl:section-end}</p>');

    this.mailtemplate = html.join('');
  }

  templateChanged() {

    let idx = this.templates.findIndex(template => {return template.name == this.mail.template});
    let template = this.templates[idx];

    this.generateDefaultMailTemplate(template);
    this.generateMailBody();

  }

  addSection() {

    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'mailComposerSectionSelectorComponent',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'sm'
    });

    modalInstance.result.then(
      function (sectionType) {

        if (sectionType == 'images') {
          that.mail.sections.push({
            type: sectionType,
            imagesPerRow: 2,
            images: [],
            heading: '',
            content: ''
          });
        } else {
          that.mail.sections.push({
            type: sectionType,
            heading: '',
            content: ''
          });
        }
      },
      function () { /* cancel */ }
    );

  }

  addTextBlock() {
    this.mail.sections.push({
      type: 'html',
      heading: '',
      content: ''
    });
  }

  addImageBlock() {
    this.mail.sections.push({
      type: 'images',
      imagesPerRow: 2,
      images: [],
      heading: '',
      content: ''
    });
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  removeAsset(section, idx) {
    section.images.splice(idx,1);
  }

  openAssetBrowserModal(section) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToUserAssets: !that.Auth.isAdminSync(),
            userId: that.Auth.getCurrentUserSync()._id,
            restrictToFileTypes: ["image/jpeg", "image/png"],
            restrictToPublicFiles: true
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        section.images =  section.images.concat(newlySelectedAssets.map(function(asset){
          return {
            title: '',
            image: asset._id
          }
        }));
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal(section) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'image/*',
            forcePublic: true
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {

          section.images.push({
            title: '',
            image: storageId
          });
        });

      },
      function () { /* cancel */ }
    );

  }

  deleteSection($event, section, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Section?", "Do you really want to delete the section '" + section.heading + "'?");
    dlg.result.then(() => {
      this.mail.sections.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  create(form, preview) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = (data) => {
        this.submitted = false;

        if (preview) {
          that.mailId = data._id;
          that.openPreviewModal();
        } else {
          var actionString = (this.mailId) ? "changed" : "created";
          var dlg = this.dialogs.notify("Success", "The page has been "+actionString+" successfully");
          dlg.result.then(() => {
            that.$location.path("/mail/"+that.mail.type+"/list");
          });
        }
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.generateMailBody();

      this.mail.attachments = this.assets.map(asset => {
        return asset._id;
      });

      if (this.mailId) {  // Save changes on the current mail
        this.MailsService.update({id: this.mailId}, this.mail, onSuccess, onError);
      } else { // Create a new mail
        this.MailsService.save(this.mail, onSuccess, onError);
      }
    }
  }

  generateMailBody() {
    const TMPL_TAG_SUBJECT = "{tmpl:subject}";
    const TMPL_TAG_CONTENT = "{tmpl:content}";
    const TMPL_TAG_DATE = "{tmpl:date}";
    const TMPL_TAG_MAIL_URL = "{tmpl:mailurl}";

    const TMPL_TAG_OPEN_SECTION = "{tmpl:section-start}";
    const TMPL_TAG_CLOSE_SECTION = "{tmpl:section-end}";

    const TMPL_HTML_FRAME = `
    <!doctype html>
      <html lang="en">
      <head>
        <meta charset="utf-8">

        <title>${TMPL_TAG_SUBJECT}</title>
        <meta name="author" content="CONDUU">

        <link rel="stylesheet" href="css/styles.css?v=1.0">

        <!--[if lt IE 9]>
          <script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.js"></script>
        <![endif]-->
      </head>

      <body>
        ${TMPL_TAG_CONTENT}
      </body>
      </html>`;

    const TMPL_HTML_FRAME2 =`
  <!doctype html>
<html>
<head>
    <meta name="viewport" content="width=device-width" />
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <title>{tmpl:subject}</title>
    <style>
        /* -------------------------------------
            GLOBAL RESETS
        ------------------------------------- */
        img {
            border: none;
            -ms-interpolation-mode: bicubic;
            max-width: 100%; }

        body {
            background-color: #f6f6f6;
            font-family: sans-serif;
            -webkit-font-smoothing: antialiased;
            font-size: 14px;
            line-height: 1.4;
            margin: 0;
            padding: 0;
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%; }

        table {
            border-collapse: separate;
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
            width: 100%; }
        table td {
            font-family: sans-serif;
            font-size: 14px;
            vertical-align: top; }

        /* -------------------------------------
            BODY & CONTAINER
        ------------------------------------- */

        .body {
            background-color: #f6f6f6;
            width: 100%; }

        /* Set a max-width, and make it display as block so it will automatically stretch to that width, but will also shrink down on a phone or something */
        .container {
            display: block;
            Margin: 0 auto !important;
            /* makes it centered */
            max-width: 580px;
            padding: 10px;
            width: 580px; }

        /* This should also be a block element, so that it will fill 100% of the .container */
        .content {
            box-sizing: border-box;
            display: block;
            Margin: 0 auto;
            max-width: 580px;
            padding: 10px; }

        /* -------------------------------------
            HEADER, FOOTER, MAIN
        ------------------------------------- */
        .main {
            background: #ffffff;
            border-radius: 3px;
            width: 100%; }

        .wrapper {
            box-sizing: border-box;
            padding: 20px; }

        .content-block {
            padding-bottom: 10px;
            padding-top: 10px;
        }

        .footer {
            clear: both;
            Margin-top: 10px;
            text-align: center;
            width: 100%; }
        .footer td,
        .footer p,
        .footer span,
        .footer a {
            color: #999999;
            font-size: 12px;
            text-align: center; }

        /* -------------------------------------
            TYPOGRAPHY
        ------------------------------------- */
        h1,
        h2,
        h3,
        h4 {
            color: #000000;
            font-family: sans-serif;
            font-weight: 400;
            line-height: 1.4;
            margin: 0;
            Margin-bottom: 30px; }

        h1 {
            font-size: 35px;
            font-weight: 300;
            text-align: center;
            text-transform: capitalize; }

        p,
        ul,
        ol {
            font-family: sans-serif;
            font-size: 14px;
            font-weight: normal;
            margin: 0;
            Margin-bottom: 15px; }
        p li,
        ul li,
        ol li {
            list-style-position: inside;
            margin-left: 5px; }

        a {
            color: #3498db;
            text-decoration: underline; }

        /* -------------------------------------
            BUTTONS
        ------------------------------------- */
        .btn {
            box-sizing: border-box;
            width: 100%; }
        .btn > tbody > tr > td {
            padding-bottom: 15px; }
        .btn table {
            width: auto; }
        .btn table td {
            background-color: #ffffff;
            border-radius: 5px;
            text-align: center; }
        .btn a {
            background-color: #ffffff;
            border: solid 1px #3498db;
            border-radius: 5px;
            box-sizing: border-box;
            color: #3498db;
            cursor: pointer;
            display: inline-block;
            font-size: 14px;
            font-weight: bold;
            margin: 0;
            padding: 12px 25px;
            text-decoration: none;
            text-transform: capitalize; }

        .btn-primary table td {
            background-color: #3498db; }

        .btn-primary a {
            background-color: #3498db;
            border-color: #3498db;
            color: #ffffff; }

        /* -------------------------------------
            OTHER STYLES THAT MIGHT BE USEFUL
        ------------------------------------- */
        .last {
            margin-bottom: 0; }

        .first {
            margin-top: 0; }

        .align-center {
            text-align: center; }

        .align-right {
            text-align: right; }

        .align-left {
            text-align: left; }

        .clear {
            clear: both; }

        .mt0 {
            margin-top: 0; }

        .mb0 {
            margin-bottom: 0; }

        .preheader {
            color: transparent;
            display: none;
            height: 0;
            max-height: 0;
            max-width: 0;
            opacity: 0;
            overflow: hidden;
            mso-hide: all;
            visibility: hidden;
            width: 0; }

        .powered-by a {
            text-decoration: none; }

        hr {
            border: 0;
            border-bottom: 1px solid #f6f6f6;
            Margin: 20px 0; }

        /* -------------------------------------
            RESPONSIVE AND MOBILE FRIENDLY STYLES
        ------------------------------------- */
        @media only screen and (max-width: 620px) {
            table[class=body] h1 {
                font-size: 28px !important;
                margin-bottom: 10px !important; }
            table[class=body] p,
            table[class=body] ul,
            table[class=body] ol,
            table[class=body] td,
            table[class=body] span,
            table[class=body] a {
                font-size: 16px !important; }
            table[class=body] .wrapper,
            table[class=body] .article {
                padding: 10px !important; }
            table[class=body] .content {
                padding: 0 !important; }
            table[class=body] .container {
                padding: 0 !important;
                width: 100% !important; }
            table[class=body] .main {
                border-left-width: 0 !important;
                border-radius: 0 !important;
                border-right-width: 0 !important; }
            table[class=body] .btn table {
                width: 100% !important; }
            table[class=body] .btn a {
                width: 100% !important; }
            table[class=body] .img-responsive {
                height: auto !important;
                max-width: 100% !important;
                width: auto !important; }}

        /* -------------------------------------
            PRESERVE THESE STYLES IN THE HEAD
        ------------------------------------- */
        @media all {
            .ExternalClass {
                width: 100%; }
            .ExternalClass,
            .ExternalClass p,
            .ExternalClass span,
            .ExternalClass font,
            .ExternalClass td,
            .ExternalClass div {
                line-height: 100%; }
            .apple-link a {
                color: inherit !important;
                font-family: inherit !important;
                font-size: inherit !important;
                font-weight: inherit !important;
                line-height: inherit !important;
                text-decoration: none !important; }
            .btn-primary table td:hover {
                background-color: #34495e !important; }
            .btn-primary a:hover {
                background-color: #34495e !important;
                border-color: #34495e !important; } }

    </style>
</head>
<body class="">
<table border="0" cellpadding="0" cellspacing="0" class="body">
    <tr>
        <td>&nbsp;</td>
        <td class="container">
            <div class="content">

                <!-- START CENTERED WHITE CONTAINER -->
                <span class="preheader"></span>

                <table class="main">

                    <!-- START MAIN CONTENT AREA -->
                    <tr>
                        <td class="wrapper">
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td>
                                        {tmpl:content}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>

                <!-- START FOOTER -->
                <div class="footer">
                    <table border="0" cellpadding="0" cellspacing="0">
                        <tr>
                            <td class="content-block">
                                <span class="apple-link"><b>Made with <a target='_blank' href="http://conduu.com">CONDUU</a></b><br/><span>IBA Technology Consultants LLC, 1200 Marine Way, North Palm Beach, FL 33408</span></span>
                            </td>
                        </tr>
                    </table>


                </div>
                <!-- END FOOTER -->


                <!-- END CENTERED WHITE CONTAINER -->
            </div>
        </td>
        <td>&nbsp;</td>
    </tr>
</table>
</body>
</html>`;

    let dynContent = "";

    let pageTemplate = TMPL_HTML_FRAME2.replace(TMPL_TAG_CONTENT, this.mailtemplate);
    pageTemplate = pageTemplate.replace(TMPL_TAG_SUBJECT, this.mail.subject);
    pageTemplate = pageTemplate.replace(TMPL_TAG_DATE, new Date().toLocaleString());
    pageTemplate = pageTemplate.replace(TMPL_TAG_MAIL_URL, this.baseUrl + '/api/mails/html/' + (this.mailId || 'unavailable'));

    let sectionTemplate = pageTemplate.substring(
      pageTemplate.lastIndexOf(TMPL_TAG_OPEN_SECTION) + TMPL_TAG_OPEN_SECTION.length,
      pageTemplate.lastIndexOf(TMPL_TAG_CLOSE_SECTION));

    for (let i=0; i<this.mail.sections.length; i++) {
      let html = sectionTemplate;

      let content = "";

      switch (this.mail.sections[i].type) {
        case 'html':
          content = this.mail.sections[i].content;
          break;
        case 'text':
          content = this.mail.sections[i].content.split(/\n/).join("<br/>");
          break;
        case 'images':

          for (let k=0; k<this.mail.sections[i].images.length; k++) {

            let baseUrl = this.baseUrl;
            let oImage = this.mail.sections[i].images[k];
            let oTitle = (oImage.title) ? "<br/><em>"+oImage.title+"</em>" : "";

            let imagesPerRow = (this.mail.sections[i].imagesPerRow) ? this.mail.sections[i].imagesPerRow : 2;
            let percent = (100 / imagesPerRow).toFixed(2);

            content += `<div style='width:${percent}%; float:left'>
                         <a target='_blank' href='${baseUrl}/api/storage/${oImage.image}'><img src='${baseUrl}/api/storage/${oImage.image}' style="width:100%"/></a>${oTitle}
                        </div>`;
          }

          content += "<div style='clear: both'></div>";

          break;
        default:
          content = this.mail.sections[i].content;
      }

      html = html.replace('{tmpl:section-heading}', this.mail.sections[i].heading);
      html = html.replace('{tmpl:section-content}', content);

      dynContent += html;
    }

    this.mail.body = pageTemplate.substring(0, pageTemplate.lastIndexOf(TMPL_TAG_OPEN_SECTION))
      + dynContent
      + pageTemplate.substring(pageTemplate.lastIndexOf(TMPL_TAG_CLOSE_SECTION) + TMPL_TAG_CLOSE_SECTION.length, pageTemplate.length);
  }

  openPreviewModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'mailComposerPreviewComponent',
      resolve: {
        config: function() {
          return {
            url: '/api/mails/html/'+that.mailId
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
      );
  }

  saveAndOpenPreviewModal(form) {
    if (!this.mailId) {
      var dlg = this.dialogs.confirm("Save and Preview Mail?", "In order to to be able to preview, the mail must be saved first.<br/>Do you want to save the mail?");
      dlg.result.then(() => {
        this.create(form, true);
      }, () => {
        // Cancel
      });
    } else {
      this.create(form, true);
    }
  }


  openAssetBrowserModalAttachment() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        newlySelectedAssets.forEach(nsa => {

          that.StorageService.getFileSize({id: nsa._id}, data2 => {
            nsa.size = 4*(data2.size/3); // calc base64 size (as 10MB is hard limit after base64 encoding)
            that.assets.push(nsa);
          });

        })
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModalAttachment() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.StorageService.getFileSize({id: storageId}, data2 => {
              data.size = 4*(data2.size/3); // calc base64 size (as 10MB is hard limit after base64 encoding)
              that.assets.push(data);
            });
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduu.mailComposer', [uiRouter])
  .config(routes)
  .component('mailComposer', {
    template: require('./mail-composer.html'),
    controller: MailComposerComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/messaging/mail/composer/mail-composer.component.js